const MetricBox = ({ title, actual, goal, color }) => {
  let bgColor = "#d1dbcf"; // default green
  if (color === "red") bgColor = "#fca5a5";
  if (color === "gray") bgColor = "#e5e7eb";

  return (
    <div className="border px-2 rounded-md shadow-sm" style={{ backgroundColor: bgColor }}>
      <p className="border-b text-center border-gray-400 py-1 head-2 dark-H">{title}</p>

      <div className="p-2 text-center">
        <p className="head-4 dark-H">Actual</p>
        <p className="mb-1">${actual?.toLocaleString()}</p>

        <p className="head-4 dark-H">Goal</p>
        <p>${goal?.toLocaleString()}</p>
      </div>
    </div>
  );
};

export default MetricBox;
